<template lang="pug">
  div.nav-bar-btn-container( :class="{'active-background' : mainPage, 'nonactive-background' : !mainPage}" )
    div.image(v-if="!mainPage")
      img(:src="require(`@/assets/navbar/${img}`)")
    div.image(v-if="mainPage")
      img(:src="require(`@/assets/navbar/${whiteImg}`)")

</template>

<script> 
export default ({
  name:"NavBarButton",

  props: {
    img:null,
    whiteImg:null,
    namePage: null
  },

  computed: {

    mainPage() {
      return (this.$route.name === this.namePage)
    }

  }
  
})
</script>

<style scoped>
.nav-bar-btn-container{
  width: 40px;
  height: 40px;
  border-radius: 16px;
  margin-right: 16px;
  display: flex;
}
.image {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF
}
.active-background {
  background: #5365E5;
}
.nonactive-background {
  background: #E5E7EB;
}
</style>